import { Link } from 'react-router-dom';
import Logo from '../../ui/Logo/Logo.jsx';
import styles from './Footer.module.css';

const columns = [
  {
    title: 'Product',
    links: [
      { to: '/solutions', label: 'Solutions' },
      { to: '/plans', label: 'Plans' },
      { to: '/design-system', label: 'Design System' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/company', label: 'About' },
      { to: '/insights', label: 'Insights' },
      { to: '/contact', label: 'Get in touch' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy Notice' },
      { to: '/terms', label: 'Terms of Use' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.top}>
          <div className={styles.brand}>
            <Link to="/" className={styles.logo}>
              <Logo size={26} />
            </Link>
            <p className={styles.tagline}>
              A modern landing page template for showcasing digital products with clarity, motion, and confidence.
            </p>
          </div>

          <div className={styles.columns}>
            {columns.map((col) => (
              <div key={col.title} className={styles.column}>
                <span className={styles.columnTitle}>{col.title}</span>
                {col.links.map((l) => (
                  <Link key={l.to} to={l.to} className={styles.columnLink}>
                    {l.label}
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.bottom}>
          <span>© {new Date().getFullYear()} Solvora. All rights reserved.</span>
          <span className={styles.status}>
            <span className={styles.dot} aria-hidden="true" />
            All systems operational
          </span>
        </div>
      </div>
    </footer>
  );
}
